import chatttSDK from 'services/chattt';
import type { AsaasHandoff } from './returnHandoff';

export function getAsaasHandoff(): AsaasHandoff {
  return chatttSDK?.openExternal ? 'desktop' : 'browser';
}
